export default function DateIcon(){
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 9.16732H2.75M14.6667 1.83398V5.50065M7.33333 1.83398V5.50065M7.15 20.1673H14.85C16.3901 20.1673 17.1602 20.1673 17.7485 19.8676C18.2659 19.6039 18.6866 19.1832 18.9503 18.6658C19.25 18.0775 19.25 17.3075 19.25 15.7673V8.06732C19.25 6.52717 19.25 5.7571 18.9503 5.16884C18.6866 4.6514 18.2659 4.2307 17.7485 3.96705C17.1602 3.66732 16.3901 3.66732 14.85 3.66732H7.15C5.60986 3.66732 4.83978 3.66732 4.25153 3.96705C3.73408 4.2307 3.31338 4.6514 3.04973 5.16884C2.75 5.7571 2.75 6.52717 2.75 8.06732V15.7673C2.75 17.3075 2.75 18.0775 3.04973 18.6658C3.31338 19.1832 3.73408 19.6039 4.25153 19.8676C4.83978 20.1673 5.60986 20.1673 7.15 20.1673Z"
        stroke="#656565"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}